import {
    getVehicles,
    addVehicle,
    editVehicle,
    deleteVehicle,
    changeStatus,
    getVehiclesIdles,
    getVehiclesLocations
} from "./vehicles.action";

export {vehiclesReducer} from "./vehicles.reducer";
export {watchVehicles} from "./vehicles.saga";

export const vehiclesActions = {
    /** Vehicles */
    getVehicles,
    addVehicle,
    editVehicle,
    deleteVehicle,
    changeStatus,
    getVehiclesIdles,
    getVehiclesLocations
};
